import { LINE_TYPES } from "@/lib/ManufacturingTags.generated";

/** Line types for which we do not show the no_competence indicator. */
export const IGNORE_COMPETENCE_FLAG = [LINE_TYPES.sick_leave, LINE_TYPES.shift_lead, LINE_TYPES.pool] as const;
